import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserValidationRequest } from 'src/app/models/UserValidationRequest.model';
import { UserValidationResult } from 'src/app/models/UserValidationResult.model';
import { RequestService } from 'src/app/services/request.service';

@Component({
  selector: 'app-usermanagement-list-change-email',
  templateUrl: './usermanagement-list-change-email.component.html',
  styleUrls: ['./usermanagement-list-change-email.component.scss']
})
export class UsermanagementListChangeEmailComponent implements OnDestroy {
  form: FormGroup;
  errors: string[] = [];
  button1: string = "Cancel";
  button2: string = "Save";
  title: string = "Change email";
  private unscubscribe$ = new Subject<void>();

  constructor(
    private requestService: RequestService,
    private dialogRef: MatDialogRef<UsermanagementListChangeEmailComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { email: string, companyId: number }) {
    this.form = new FormGroup({
      email: new FormControl(null, Validators.required),
    });
    this.dialogRef.disableClose = true;
  }

  overrideEmail() {
    var mail = this.form.get('email').value;

    let userValidationRequest: UserValidationRequest = {
      email: mail,
      password: null,
      repeatPassword: null,
      companyId: this.data.companyId
    };

    this.requestService.validateUser(userValidationRequest).pipe(takeUntil(this.unscubscribe$))
      .subscribe((response: UserValidationResult) => {
        if (response.success) {
          this.dialogRef.close({ save: true, data: { newEmail: mail, email: this.data.email } });
        }
        else {
          this.errors = response.errors;
        }
      });
  }

  cancel() {
    this.dialogRef.close({ save: false, data: null });
  }

  ngOnDestroy(): void {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
  }
}
